<li class="expandable-list__item panel-info">
  <div class="expandable-list__item__header" [class.opened]="opened" (click)="onItemClick()" [attr.aria-expanded]="opened">
    <h5>{{ title }}</h5>
    <i class="icon icon-ui-{{ opened ? 'minus' : 'plus' }}"></i>
  </div>
  <div class="expandable-list__item__body" [@expanded]="opened">
    <ng-content></ng-content>
  </div>
</li>
